import React from 'react';
import GallectionsGridView from './GallectionsGridView';
import GallectionsGridViewContainer, {
  OwnProps,
} from './GallectionsGridView.container';

export default GallectionsGridViewContainer(
  GallectionsGridView
) as React.ComponentType<OwnProps>;
